var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0199 5.31295C12.2152 5.50821 12.2152 5.8248 12.0199 6.02006L7.35323 10.6867C7.15797 10.882 6.84138 10.882 6.64612 10.6867L3.97945 8.02006C3.78419 7.8248 3.78419 7.50821 3.97945 7.31295C4.17472 7.11769 4.4913 7.11769 4.68656 7.31295L6.99967 9.62606L11.3128 5.31295C11.5081 5.11769 11.8246 5.11769 12.0199 5.31295Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.adec4cadf6564ea8f1337b4c4ab6adf1.svg";
export { ForwardRef as ReactComponent };